import LandingPage from './LandingPage';
import Contact from './Contact';
import Skills from './Skills';
import WhatWeOfferPage from '../components/Domain/WhatWeOffer';
import Services from '../components/Services/service';
import OurProcess from '../components/Process/process';
import Testimonial from '../components/Testimonials/Testimonial';
import BookCallFloatController from '../components/BookCall/BookCallFloatController.tsx'; // 👈 add

export default function Home() {
  return (
    <div>
      <LandingPage/>           {/* hero keeps inline CTA on the left-mid */}
      <Services />
      <WhatWeOfferPage />
      <Skills />
      <OurProcess />
      <Testimonial />
      <Contact />

      {/* 👇 Shows floating CTA only when hero is NOT visible */}
      <BookCallFloatController />
    </div>
  );
};
